// extracted by mini-css-extract-plugin
export var searchbar = "SearchBar-module--searchbar--AnW+X";
export var submitButton = "SearchBar-module--submitButton--BRNS5";